/**
 * Term Overview Block - Tab Functionality
 * Uses the global TabsComponent for consistent tab behavior
 */
import { TabsComponent } from '../../src/js/components/tabs';

// Initialize tabs for term overview blocks with specific configuration
const termOverviewTabs = new TabsComponent({
	containerSelector: '.term-overview',
	buttonSelector: '[data-filter]',
	contentSelector: '[data-tab-content]',
	activeClass: 'active',
	showMethod: 'grid',
	hideMethod: 'none',
});
